import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Typography } from '@mui/material';

import { useStyles } from './styles';
import { env } from 'env';

const LegalNotes = () => {
  const classes = useStyles();
  const { t: translate } = useTranslation();

  const { REACT_APP_TERMS_OF_SERVICE, REACT_APP_PRIVACY_POLICY } = env;

  return (
    <Typography sx={classes.text}>
      {translate('legalNotes.preFix')}{' '}
      <Link href={REACT_APP_TERMS_OF_SERVICE} target="_blank" sx={classes.link}>
        {translate('legalNotes.terms')}
      </Link>{' '}
      {translate('legalNotes.and')}{' '}
      <Link href={REACT_APP_PRIVACY_POLICY} target="_blank" sx={classes.link}>
        {translate('legalNotes.privacy')}
      </Link>
    </Typography>
  );
};

export default LegalNotes;
